import React from 'react';
import { AuditLogTable } from '@hofsync/design-system';
import { useAuditEvents } from '../../hooks/useAuditEvents';
import './EntityHistoryPanel.css';

interface EntityHistoryPanelProps {
  entityType: string;
  entityId: string;
}

const SKELETON_ROWS = 4;

const EntityHistoryPanel: React.FC<EntityHistoryPanelProps> = ({ entityType, entityId }) => {
  const { entries, isLoading, isError, refetch } = useAuditEvents({
    scope: { object_type: 'twin_entity', entity_type: entityType, entity_id: entityId },
  });

  if (isError) {
    return (
      <div className="entity-history-panel entity-history-panel--error">
        <p className="entity-history-panel__error-message">
          Aktivitäten konnten nicht geladen werden.
        </p>
        <button
          type="button"
          className="entity-history-panel__retry"
          onClick={() => refetch()}
        >
          Erneut versuchen
        </button>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="entity-history-panel entity-history-panel--loading">
        {Array.from({ length: SKELETON_ROWS }).map((_, i) => (
          <div
            key={i}
            data-testid="entity-history-skeleton-row"
            className="entity-history-panel__skeleton-row"
          />
        ))}
      </div>
    );
  }

  return (
    <div className="entity-history-panel">
      <AuditLogTable entries={entries} emptyMessage="Keine Aktivitäten" />
    </div>
  );
};

export default EntityHistoryPanel;
